export const calculationConstants = {
  RETIREMENT_GOAL_REQUEST: "RETIREMENT_GOAL_CALCULATION_REQUEST",
  RETIREMENT_GOAL_SUCCESS: "RETIREMENT_GOAL_CALCULATION_SUCCESS",
  RETIREMENT_GOAL_FAILURE: "RETIREMENT_GOAL_CALCULATION_FAILURE",
};
